<div class="bg-th-yellow mt-0 container-fluid" *ngIf="std_PhoneNumber == undefined && !isContracts ">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2">

            {{ bPersonnel ? 'ثبت پرسنل' : 'ثبت دانش آموز' }}


        </span>

    </div>

</div>

<section class="container dirI">

    <div [ngClass]="isContracts ? '' : 'm-4' ">

        <div *ngIf="std_PhoneNumber == undefined && !isContracts" [ngClass]="isContracts ? 'col-10' : 'col-md-6 col-12'">

            <form #form="ngForm" (ngSubmit)="studentSearch(form)" class="input-group mb-1">

                <input oninput="this.value = this.value.replace(/[^0-9]/g,'')" minlength="11" maxlength="11" required
                    (input)="showResult=false" required ngModel name="strMobile" class="form-control rounded"
                    [placeholder]="bPersonnel ? 'شماره موبایل پرسنل را وارد کنید' : 'شماره موبایل اصلی والدین را وارد کنید' ">

                <button class="mx-2 btn btn-primary rounded" type="submit">

                    <span class="px-2"> بررسی </span>

                    <i class="fa fa-search"></i>

                </button>

            </form>

        </div>

        <div class="form py-3" *ngIf="showResult">

            <form #student="ngForm" (ngSubmit)="newStudent(student)" class="row gx-2 gy-3 py-3 px-2 border border-3 rounded">

                <!-- تصویر -->

                <div class="col-12 col-md-3 p-2">

                    <div class="d-flex justify-content-center">

                        <div class="position-relative" style="width: fit-content;">

                            <img class="rounded-circle border border-1 border-dark p-1" style="object-fit: contain;"
                                width="150" height="150"
                                src="{{ strAvatar != '' ? 'data:image/jpeg;base64,' + strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}"
                                alt="{{list_StudentData?.strName + list_StudentData?.strFamily}}">

                            <i class="fa fa-plus-circle fa-2x position-absolute" (click)="fileInput.click()"
                                aria-hidden="true"></i>

                            <input hidden type="file" #fileInput
                                (change)="onFileInput($event.target.files[0]);bAvatar=true" />

                        </div>

                    </div>

                </div>
                
                <div class="col-12 col-md-9 row gx-2 gy-2 p-2">
            
                    <!-- موبایل والدین -->

                    <ng-container *ngIf="isContracts">

                        <div class="col-md-3 col-12">

                            <label for="strMobile" class="text-danger">

                                موبایل والدین

                            </label>

                            <input type="text" (change)="latoLong.get('strMobile')?.setValue($event.target.value)"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')" minlength="11" maxlength="11"
                                required name="strMobile" class="form-control">

                        </div>

                    </ng-container>

                    <!-- نام -->

                    <div class="col-md-3 col-12">

                        <label for="strName" class="text-danger">

                            {{bPersonnel ? 'نام پرسنل' : 'نام '}}

                        </label>

                        <input type="text" required [ngModel]="list_StudentData?.strName" name="strName"
                            class="form-control">

                    </div>

                    <!-- نام خانوادگی -->

                    <div class="col-md-3 col-12">

                        <label for="strFamily" class="text-danger">

                            {{bPersonnel ? 'نام خانوادگی پرسنل' : 'نام خانوادگی' }}


                        </label>

                        <input required type="text" [ngModel]="list_StudentData?.strFamily" name="strFamily"
                            class="form-control">

                    </div>

                    <!-- جنسیت -->

                    <div [ngClass]="list_StudentData != undefined || isContracts ? 'col-md-3 col-12' : 'col-md-3 col-12' ">

                        <label class=""> {{ bPersonnel ? 'جنسیت' : 'جنسیت دانش آموز' }} </label>

                        <select required class="form-control"
                            [ngModel]="list_StudentData != undefined ? list_StudentData?.tiSex : 1 " name="tiSex">

                            <option value="1">آقا</option>

                            <option value="2">خانم</option>

                        </select>

                    </div>

                    <ng-container *ngIf="!bPersonnel">

                        <!-- شهر -->

                        <div [formGroup]="mdlSchool" class="col-md-3 col-12 position-relative">

                            <label style="z-index: 10;"> شهر </label>

                            <custom-filter *ngIf="lst_City.length"
                                [strValue]="returnStrValue('strCity',list_StudentData ? list_StudentData.strCity : '',lst_City,'strCityName')"
                                [strComment]="'strCityName'" [stylesArray]="['padding-top: 10px']"
                                [str_Placeholder]="'نام شهر را جستجو کنید'" [lst_Main]="lst_City"
                                [lst_SearchKey]="'strCityName'" [isDisabled]="false" name="strCity"
                                (hideOptions)="setCity($event);updateSchool(student)">

                            </custom-filter>

                        </div>

                        <!-- ناحیه -->

                        <div class="col-md-3 col-12">

                            <label class=""> ناحیه </label>

                            <select required class="form-control"
                                [ngModel]="list_StudentData ? list_StudentData.tiEducationDistrict : '' "
                                name="tiEducationDistrict" (change)="updateSchool(student)">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lstDistrict"
                                    [value]="item.tiEducationDistrict">

                                    {{ item.strComment }}

                                </option>

                            </select>

                        </div>

                        <!-- نوع مدرسه -->

                        <div class="col-md-3 col-12">

                            <label class=""> نوع مدرسه </label>

                            <select required class="form-control"
                                [ngModel]="list_StudentData ? list_StudentData?.tiSchoolType : '' " name="tiSchoolType"
                                (change)="updateSchool(student)">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option *ngFor="let item of lstSchoolType" [value]="item.tiSchoolType">

                                    {{ item.strComment }}

                                </option>

                            </select>

                        </div>

                        <!-- مقطع تحصیلی -->

                        <div class="col-md-3 col-12">

                            <label class=""> مقطع تحصیلی </label>

                            <select required class="form-control"
                                [ngModel]="list_StudentData ? list_StudentData?.tiEducationLevel : '' "
                                name="tiEducationLevel" (change)="updateSchool(student)">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lstLevel_List"
                                    [value]="item.tiEducationLevel">

                                    {{ item.strComment }}

                                </option>

                            </select>

                        </div>

                        <!-- جنسیت -->

                        <div class="col-md-3 col-12">

                            <label class=""> جنسیت </label>

                            <select required class="form-control"
                                [ngModel]="list_StudentData ? list_StudentData?.tiGender : '' " name="tiGender"
                                (change)="updateSchool(student)">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" value="-1"> نا مشخص </option>

                                <option class="text-center" value="0"> پسر </option>

                                <option class="text-center" value="1"> دختر </option>

                                <option class="text-center" value="2"> مختلط </option>

                            </select>

                        </div>

                    </ng-container>

                    <!-- نام مدرسه - نام حوزه خدمت -->

                    <div [ngClass]="bPersonnel ? 'col-md-3 col-12' : 'col-md-8 col-12' " class=" position-relative">

                        <label style="z-index: 10;"> {{ bPersonnel ? ' حوزه خدمت' : 'نام مدرسه' }} </label>

                        <custom-filter *ngIf="list_Schools.length" [strValue]="searchT_School"
                            [strComment]=" bPersonnel ? 'strComment' : 'strCombinedDescription' "
                            [stylesArray]="['padding-top: 10px']" [str_Placeholder]="'نام مدرسه را جستجو کنید'"
                            [lst_Main]="list_Schools"
                            [lst_SearchKey]="[ bPersonnel ? 'strComment' : 'strCombinedDescription']" [isDisabled]="false"
                            (hideOptions)="iMobileDomain = $event.iMobileDomain;">

                        </custom-filter>

                    </div>

                    <!-- کد ملی -->

                    <div class="col-md-4 col-12">

                        <label for="strNationalCode"> {{bPersonnel ? 'کد ملی پرسنل' : 'کد ملی ' }} </label>

                        <input dir="ltr" [ngModel]="list_StudentData?.strNationalCode.trim()" name="strNationalCode"
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')" maxlength="10"
                            class="form-control rounded">

                    </div>

                    <!-- وضعیت -->

                    <div class="col-md-3 col-12" *ngIf="list_StudentData == undefined">

                        <label for="bActive">وضعیت</label>

                        <select class="form-control"
                            [ngModel]="list_StudentData != undefined ? list_StudentData?.bActive : true " name="bActive">

                            <option [value]="true">فعال</option>

                            <option [value]="false">غیرفعال</option>

                        </select>

                    </div>

                    <!-- پایان اعتبار -->

                    <div class="col-md-3 col-12">

                        <form [formGroup]="dateFilter">

                            <label for="strExpireDate">تاریخ پایان اعتبار </label>

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">

                                <input dir="ltr" formControlName="strExpireDate" class="form-control rounded">

                            </ng-persian-datepicker>

                        </form>

                    </div>

                    <!-- پایه تحصیلی -->

                    <div class="col-md-3 col-12" *ngIf="!bPersonnel">

                        <label> پایه تحصیلی </label>

                        <select required class="form-control"
                            [ngModel]="list_StudentData != undefined ? list_StudentData?.tiGrade : 0 " name="tiGrade">

                            <option *ngFor="let item of list_Grade" [value]="item.tiGrade"> {{item.strGrade}} </option>

                        </select>

                    </div>

                    <!-- کلاس -->

                    <div class="col-md-3 col-12" *ngIf="!bPersonnel">

                        <label> کلاس </label>

                        <select required class="form-control"
                            [ngModel]="list_StudentData != undefined ? list_StudentData?.tiClassNo : 0 " name="tiClassNo">

                            <option *ngFor="let item of list_Class" [value]="item.tiClassNo"> {{item.strTitel}} </option>

                        </select>

                    </div>

                    <!-- کلید RFID -->

                    <div class="col-12 col-md-3">

                        <label for="strRFIDCodes"> کلید RFID </label>

                        <input dir="ltr" [ngModel]="list_StudentData?.strRFIDCodes" name="strRFIDCodes" maxlength="100"
                            class="form-control rounded">

                    </div>

                    <!-- وضعیت -->

                    <div [ngClass]="list_StudentData?.iPassenger != undefined ? 'd-flex align-items-end col-auto' : 'd-none' ">

                        <div class="col-12 p-2 form-check form-switch m-0 d-flex align-items-center">
        
                            <input class="form-check-input m-0" type="checkbox" id="bActive" [ngModel]="list_StudentData != undefined ? list_StudentData?.bActive : false " name="bActive">
        
                            <label class="form-check-label pointer text-muted me-2" for="bActive"> فعال </label>
        
                        </div>

                    </div>

                    <!-- دسترسی محدوده -->

                    <div class="d-flex align-items-end col-auto">

                        <div class="col-12 p-2 form-check form-switch m-0 d-flex align-items-center">
        
                            <input class="form-check-input m-0" type="checkbox" id="bStudentsDeActive" [ngModel]="list_StudentData != undefined ? list_StudentData?.bStudentsDeActive : false " name="bStudentsDeActive">
        
                            <label class="form-check-label pointer text-muted me-2" for="bStudentsDeActive"> دسترسی محدوده </label>
        
                        </div>

                    </div>

                    <!-- آدرس سوار شدن -->

                    <div class="col-12 position-relative">

                        <label for="strAddress">آدرس سوار شدن</label>

                        <input [ngModel]="list_StudentData?.strAddress" id="strAddress" name="strAddress"
                            class="form-control col-md-10 py-2">

                        <button class="mx-2 btn btn-warning location-button rounded position-absolute" type="button"
                            (click)="getAddress()">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                        </button>

                    </div>

                    <!-- طول جغرافیایی -->

                    <div class="col-md-4 col-12 x">

                        <label for="fOriginLon">طول جغرافیایی</label>

                        <input [ngModel]="list_StudentData?.fOriginLon | number:'1.5-5'" name="fOriginLon" id="fOriginLon"
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')" class="form-control text-end">

                    </div>

                    <!-- عرض جغرافیایی -->

                    <div class="col-md-4 col-12 x">

                        <label for="fOrigiLat">عرض جغرافیایی</label>

                        <input [ngModel]="list_StudentData?.fOrigiLat | number:'1.5-5'" name="fOrigiLat" id="fOrigiLat"
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')" class="form-control text-end">

                    </div>

                    <!-- فاصله تا -->

                    <div class="col-md-4 col-12 position-relative">

                        <label for="fDistance"> {{ bPersonnel ? 'فاصله تا حوزه خدمت' : 'فاصله تا مدرسه' }}</label>

                        <input name="fDistance" [ngModel]="list_StudentData?.fDistance" id="distance"
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')" class="form-control x text-center">

                        <button class="mx-2 btn btn-success calc-button rounded position-absolute" type="button"
                            (click)="calcDistance(iMobileDomain.value)">

                            <i class="fa fa-calculator fa-lg" aria-hidden="true"></i>

                        </button>

                    </div>

                    <!-- دکمه ها -->

                    <div class="col-12 text-start mb-2 mt-3">

                        <button *ngIf="list_StudentData?.iPassenger != undefined && bReCalDistance && !isContracts"
                            class="col-12 me-2 col-md-auto btn btn-info rounded" type="button" (click)="costCalculate()">

                            <span class="px-2"> محاسبه سرویس </span>

                        </button>

                        <button
                            [ngClass]="list_StudentData?.iPassenger != undefined && !isContracts ? 'mx-md-2 btn-primary' : 'btn-success' "
                            class="my-2 my-md-0 col-12 col-md-auto btn rounded" type="submit">

                            <span class="px-2">

                                {{ list_StudentData?.iPassenger != undefined && !isContracts ? 'ویرایش' : 'ذخیره'}}

                            </span>

                        </button>

                        <button *ngIf="list_StudentData?.iPassenger != undefined && !isContracts"
                            class="col-12 col-md-auto btn btn-danger rounded" type="button" (click)="deleteStudent()">

                            <span class="px-2"> حدف </span>

                        </button>

                    </div>

                </div>

            </form>

        </div>

    </div>

</section>

<div class="modal fade" id="maplat" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
    data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title">ثبت موقعیت</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div id="map" class="position-sticky w-100 " style="height: 500px;">

                <div [formGroup]="latoLong"
                    class="d-flex justify-content-around position-absolute dirI bg-th-yellow w-100 p-1"
                    style="z-index: 1000; margin-bottom: 10px;">

                    <div class="mx-1">

                        <label for="lat">عرض جغرافیایی: </label>

                        <input readonly id="lat" type="text" formControlName="latIn" class="mx-2" #lat>

                    </div>

                    <div class="mx-1">

                        <label for="lon">طول جغرافیایی: </label>

                        <input readonly id="lon" type="text" formControlName="longIn" class="mx-2">

                    </div>

                </div>

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

            <button (click)="confirmLatol()" *ngIf="lat.value != ''" data-bs-dismiss="modal"
                class="btn btn-success">تایید <i class="fa fa-check"></i></button>

        </div>

    </div>

</div>

<ng-container *ngIf="isLoading" class="">

    <div class="school_loading">

        <img *ngIf="!bPersonnel" src="../../../../assets/Img/school_2.gif" alt="loading">

        <p *ngIf="bPersonnel"> ... لطفا منتظر بمانید </p>

    </div>

</ng-container>